// Utilizes CSS Element Queries to detect dimension changes to any container element, similar to how @media works.
// ResizeObserver was an option but it is Chrome only. The polyfill crashes on IE/Edge.

import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { ResizeSensor } from 'css-element-queries';
import { Subscription } from 'rxjs';

import { TranslationKeyMap } from '../coaching-insight.i18n';

import { ElasticUIService } from './services/elastic-ui.service';

export interface Dimensions {
    height: number;
    width: number;
}
export interface DimensionData {
    dimensions?: Dimensions;
    index?: number;
}

// maintain a list of Team Member Metrics
@Directive({
    selector: '[elasticElement]',
})
export class ElasticElementDirective implements OnInit, OnDestroy {
    @Input() useElasticService = true;
    @Input() dimensionIndex = null;
    @Output() resized: EventEmitter<Dimensions> =
        new EventEmitter<Dimensions>();

    index: number;

    resizesub: Subscription;
    origWidth: number;
    unbind: any;
    updater: any;
    listener: any;

    i18n = TranslationKeyMap;

    constructor(
        protected readonly _el: ElementRef,
        private readonly _elasticService: ElasticUIService,
    ) {}

    ngOnInit(): void {
        this.listener = new ResizeSensor(
            this._el.nativeElement,
            (dimensions) => {
                this.update(dimensions);
                if (!this.useElasticService) {
                    this.resized.emit(dimensions);
                } else {
                    this.update(dimensions);
                }
            },
        );
    }

    ngOnDestroy(): void {
        if (this.useElasticService) {
            this._elasticService.removeSet(
                this.dimensionIndex !== null ? this.dimensionIndex : this.index,
            );
        }
        this.listener.detach();
        this.listener = null;
    }

    ngAfterViewInit(): void {
        if (this.useElasticService) {
            setTimeout(() => {
                const o = this._el.nativeElement.getBoundingClientRect();

                this.index = this._elasticService.addDimensionSet(
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    {
                        height: o.height,
                        width: o.width,
                    } as Dimensions,
                    this.dimensionIndex !== null ? this.dimensionIndex : null,
                );
            });
        }
    }

    update(dims: Dimensions): void {
        this._elasticService.updateElementSet(
            this.dimensionIndex !== null ? this.dimensionIndex : this.index,
            dims,
        );
    }
}
